import { useAppConfigContext } from '@/context/AppContext';
import useGTM from '@/hooks/useGTM';
import useToast from '@/hooks/useToast';
import Div from '@/shared/Div';
import Image from '@/shared/Image';
import Link from '@/shared/Link';
import copyToClipboard from '@/utils/copyToClipboard';
import classNames from 'classnames';
import dlv from 'dlv';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const PromoBanner = ({
  className,
  keyForDsk = 'dskImage',
}: {
  className?: string;
  keyForDsk?: string;
}) => {
  const { state: appConfig } = useAppConfigContext();
  const { triggerSuccess } = useToast();
  const promo = dlv(appConfig, 'config.promoOffers.promo2', null);

  const router = useRouter();
  const { fireGTMEvent } = useGTM();

  useEffect(() => {
    if (promo && promo?.flag) {
      fireGTMEvent(
        'promo_banner_view',
        {
          promo_id: promo.id,
          promo_code: promo.value,
          screen: router.pathname,
        },
        {
          webengage: {
            fire: true,
            isDirect: true,
          },
        },
      );
    }
  }, [promo]);

  if (!promo || !promo?.flag) return null;
  const { id, cta } = promo;

  const handleCtaClick = async () => {
    const success = await copyToClipboard(promo.value || '');

    if (success) {
      triggerSuccess({
        message: `Promo code ${promo.value} copied to clipboard!`,
        position: 'top',
      });
    }

    fireGTMEvent(
      'promo_banner_cta_clicked',
      {
        promo_id: promo.id,
        promo_code: promo.value,
        screen: router.pathname,
      },
      {
        webengage: {
          fire: true,
          isDirect: true,
        },
      },
    );

    if (cta && cta.href) {
      router.push({
        pathname: cta.href,
      });
    }
  };

  return (
    <Div id={id} className={classNames(className)}>
      <Link href={cta?.href || '#'} onClick={handleCtaClick} className="block">
        <Image src={promo['mobImage']} alt="Promo Offer" className="w-full md:hidden" />
      </Link>
      <Link href={cta?.href || '#'} onClick={handleCtaClick} className="block">
        <Image src={promo[keyForDsk]} alt="Promo Offer" className="w-full hidden md:block" />
      </Link>
    </Div>
  );
};

export default PromoBanner;
